module.exports = __webpack_public_path__ + "media/img/virtual-internships/student-testimonial-brandy-yuan-c7f498fc3aaa0e150af39f2a1be5fb77.png";